// bulkUploadReducer.js
import {
    INIT_BULK_UPLOAD_REQUEST,
    SET_BULK_UPLOAD,
    ERROR_BULK_UPLOAD,
    BULK_UPLOAD_PROGRESS,
  } from './action';
  
  const initialState = {
    isLoading: false,
    uploadData: null,
    error: null,
    progress: 0,
  };
  
  const bulkUploadReducer = (state = initialState, action) => {
    switch (action.type) {
      case INIT_BULK_UPLOAD_REQUEST:
        return {
          ...state,
          isLoading: true,
          error: null,
          progress: 0,
        };
      case SET_BULK_UPLOAD:
        return {
          ...state,
          isLoading: false,
          uploadData: action.payload,
          error: null,
          progress: 100,
        };
      case ERROR_BULK_UPLOAD:
        return {
          ...state,
          isLoading: false,
          error: action.payload,
          progress: 0,
        };
      case BULK_UPLOAD_PROGRESS:
        return {
          ...state,
          progress: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default bulkUploadReducer;
  